import { cn } from 'src/lib/utils';

type Props = {
  activityNotificationNode: React.ReactNode;
  disruptedAccessNotificationNode: React.ReactNode;
  className?: string;
};
const PartyNotificationSettings = ({ activityNotificationNode, disruptedAccessNotificationNode, className }: Props) => {
  return (
    <div className={cn('grid grid-cols-1 gap-10 md:grid-cols-2', className)}>
      {activityNotificationNode}
      {disruptedAccessNotificationNode}
    </div>
  );
};

export default PartyNotificationSettings;
